/** @format */

export default {
  onTableData(
    o: {
      totalAmount: any;
      paidAmount: any;
      discountAmount: any;
      unpaidAmount: any;
      cancelAmount: any;
      pkOrderId: string;
      parkName: string;
      isTotalRow: boolean;
    }[],
    resData: { total: any; datas: any }
  ) {
    const totals = resData.total;

    if (totals != null && Array.isArray(resData.datas) && resData.datas.length > 0) {
      totals.isTotalRow = true;
      o.push(totals);
    }

    // console.log('on table data invoked', resData)
    return o;
  },
  reviewDescriptionOfDialog: undefined as any,
  detailDialogType: undefined as any,
  getImgRenderFunInDetailDialog: undefined as any,
  onDetail(o: any) {
    this.reviewDescriptionOfDialog = '';
    const basicInfo = o['基本信息'];
    const self = this;
    const tempFields = basicInfo.fields;
    basicInfo.fields = tempFields.filter(
      (item: { label: string }) =>
        !item.label.startsWith('审核') && !(item.label.includes('收') || item.label.includes('金额'))
    );
    let reviewInfo;
    if ('DETAIL' == this.detailDialogType) {
      reviewInfo = {
        fields: tempFields.filter((item: { label: string }) => item.label.startsWith('审核')),
        data: basicInfo.data
      };
    }
    if ('REVIEW' == this.detailDialogType) {
      reviewInfo = {
        fields: [
          {
            label: '审核意见',
            render(
              c: (
                arg0: string,
                arg1: {
                  attrs: { placeholder: string };
                  style: { 'max-width': string; width: string };
                  on: { change(e: any): void };
                },
                arg2: string
              ) => any
            ) {
              return c(
                'a-textarea',
                {
                  attrs: {
                    placeholder: '请输入审核意见4'
                  },
                  style: {
                    'max-width': '300%',
                    width: '300%'
                  },

                  on: {
                    change(e: { target: { value: any } }) {
                      self.reviewDescriptionOfDialog = e.target.value;
                      console.log('this is on change--:', e.target.value);
                    }
                  }
                },
                ''
              );
            }
          }
        ],
        data: basicInfo.data
      };
    }
    console.log('basicInfo.fields--:', basicInfo.fields);
    self.getImgRenderFunInDetailDialog.call(self, basicInfo, 'img');

    return {
      ...o,

      // 收费信息: {
      //   data: basicInfo.data,
      //   fields: tempFields.filter(item => item.label.includes('收') || item.label.includes('金额')),
      // },
      审核信息: reviewInfo
    };
  },
  $store: undefined as any,
  current: undefined as any,
  pageSize: undefined as any,
  onSearch(o: any) {
    if (this.$store.state.organizations.userOrg.length == 1) {
      o.org = this.$store.state.organizations.userOrg[0].id;
    } else {
      o.org = this.$store.state.organizations.userOrg
        .filter((item: { parentId: any[] }) => item.parentId == [o.org])
        .map((item: { id: any }) => item.id);
    }

    return {
      parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
      org: o.org instanceof Array ? o.org.join(',') : o.org,
      currPage: this.current,
      // plate: o.adapterDataForViewModel.plateHead + o.adapterDataForViewModel.plateTail,
      // userId: '',
      pageSize: this.pageSize
    };
  }
};
